import Image from 'next/image';
import React from 'react';
import {
  AwardCard,
  AwardImg,
  AwardsContainer,
  AwardsSection,
  PrTitle,
} from './styled';

const Awards = () => {
  const awardsStaticData = [
    {
      title: 'Mylo wins Forbes D2C Disruptor award',
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683098787247-forbes.webp',
      url: '',
    },
    {
      title: 'Mylo wins The Economic Times Promising Brands 2022',
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683098787247-promising_brand.webp',
      url: '',
    },
  ];
  return (
    <AwardsSection>
      <PrTitle award={true}>AWARDS AND RECOGNITION</PrTitle>
      <AwardsContainer>
        {awardsStaticData.map((award, index) => {
          return (
            <AwardCard key={index}>
              <AwardImg>
                <Image
                  src={award.imgUrl}
                  loading="lazy"
                  height={140}
                  width={index === 0 ? 140 : 210}
                  alt={'Awards'}
                />
              </AwardImg>
              <p>{award.title}</p>
            </AwardCard>
          );
        })}
      </AwardsContainer>
    </AwardsSection>
  );
};

export default Awards;
